var map = {
	"./energy.jpg": 3198,
	"./sleep.jpg": 1212,
	"./sooth.jpg": 9307,
	"./sunrise.jpg": 9890,
	"./sunset.jpg": 5682,
	"./young.jpg": 8782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4747;